import React, { useEffect } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import ExitToAppRoundedIcon from "@material-ui/icons/ExitToAppRounded";
import {
  isImpersonating,
  impersonatedCompanyName,
  exitImpersonation,
} from "../../helpers/impersonate";

// Persistent, high-contrast bar shown app-wide whenever a super-admin is
// impersonating a tenant. Makes the state unmistakable and gives a one-click
// return to the admin console (restores the backed-up super-admin token).
export default function ImpersonationBanner() {
  const active = isImpersonating();

  useEffect(() => {
    if (!active) return undefined;
    const prev = document.body.style.paddingTop;
    document.body.style.paddingTop = "36px";
    return () => {
      document.body.style.paddingTop = prev;
    };
  }, [active]);

  if (!active) return null;

  return (
    <Box
      role="status"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 21000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: 12,
        height: 36,
        padding: "0 12px",
        backgroundColor: "#b45309",
        color: "#fff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.28)",
      }}
    >
      <Typography
        variant="body2"
        style={{ fontWeight: 600, color: "#fff", fontSize: 13 }}
      >
        Impersonating {impersonatedCompanyName()} — you are acting as their admin
      </Typography>
      <Button
        size="small"
        variant="contained"
        startIcon={<ExitToAppRoundedIcon />}
        onClick={exitImpersonation}
        style={{
          backgroundColor: "#fff",
          color: "#b45309",
          fontWeight: 700,
          height: 26,
          minWidth: 0,
        }}
      >
        Exit to admin
      </Button>
    </Box>
  );
}
